import { bl_fi_my_einvoice_batch_pool_doc_hdr_RowClass } from '../../dbschema/bl_fi_my_einvoice_batch_pool_doc_hdr.model';
import { BaseContainerModel } from '../base-container.model';

export class MyEInvoiceBatchPoolDocHdrContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_batch_pool_doc_hdr: bl_fi_my_einvoice_batch_pool_doc_hdr_RowClass = new bl_fi_my_einvoice_batch_pool_doc_hdr_RowClass();
}
